export default "__VITE_ASSET__e7f3cd46__"